import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import App from './App';

const rootElement = document.getElementById('root');


// other browser

ReactDOM.render(
    <div>
        <BrowserRouter basename={'/'}>
            <App />
        </BrowserRouter>
    </div>,
  rootElement);


